<template>
  <div>
    <PageTagline :elements="tagline_elem" />

    <!-- Overlay da usare durante il caricamento delle info e durante la generazione del pin -->
    <CustomOverlay :show="overlay_show" :text="overlay_text">

      <!--CARD PRINCIPALE DI CONTENIMENTO DELLA PAGINA -->
      <b-card title="Gestione Pin Utente">
        <b-row>
          <b-col>
            <p class="text-justify">
              Genera il pin da utilizzare per la conferma delle operazioni particolamente sensibili come la conferma delle
              transazioni di addebito sui voucher acquistati presso il nostro welfare di prossimità.
            </p>
            <p class="text-justify">
              Potrai generare il pin in qualsiasi momento ed anche rigenerarlo nel caso lo avessi già fatto. La generazione
              di un nuovo pin utente <u>annulla automaticamente quello precedente.</u>
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-3" align-h="center">
          <!-- Uso le classi di bootstrap per ordinare le due colonne: -->
          <!-- In mobile si segue l'ordine con cui le due colonne sono scritte, quindi prima la -->
          <!-- descrizione e poi il pulsante. Nella vesione desktop con le classi order-md-last -->
          <!-- e order-md-first ribalto l'ordine e pongo prima il pulsante, che compare a       -->
          <!-- sinistra e poi la descrizione che va a destra.                                   -->
          <b-col md="4" class="order-md-last">
            <p v-if="pin_exists" class="font-italic text-justify text-success">Hai già un pin utente valido. Se vuoi generarne uno nuovo clicca sul pulsante.</p>
            <p v-else class="font-italic text-justify text-danger">Non hai ancora un pin utente valido, clicca sul pulsante per generalo.</p>
          </b-col>
          <b-col md="2" class="order-md-first">
            <b-button block variant="danger" @click="conferma_generazione_pin">Genera Nuovo Pin</b-button>
          </b-col>
        </b-row>
      </b-card>
    </CustomOverlay>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import CustomOverlay from '@/components/CustomOverlay'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'GestionePin',
  data () {
      return {
        // Variabili generali
        tagline_elem : [ { text : "Convenzioni special/On Demand", link : 'home-fornitori' },
                         { text : "Gestione Pin Utente", link : 'gestione-pin' } ],
        overlay_show: false,
        overlay_text : null,

        // Flag che indica se il pin esiste, default a false,
        // da inizializzare al caricamento della pagina.
        pin_exists : false
      }
  },
  methods : {
    /**
     * Lancia la finestra di conferma per la generazione di un nuovo pin.
     */
    conferma_generazione_pin : function () {

      let message = "L'azione non può essere interrotta, si è sicuri di continuare?";
      if ( this.pin_exists ){
        message = "La generazione di un nuovo pin utente renderà inutilizzabile il vecchio. " +
                  "L'azione non può essere interrotta, si è sicuri di continuare?";
      }

      this.$bvModal.msgBoxConfirm( message, {
          title: 'Conferma Necessaria',
          size: 'md',
          okVariant: 'primary',
          okTitle: 'Procedi',
          cancelTitle: 'Annulla',
          hideHeaderClose: true,
          centered: true
        })
        .then( ( answer ) => {
          if ( answer === true ) this.genera_nuovo_pin();
        });
    },
    /**
     * Genera un nuovo pin utente, se ne esisteva già uno il vecchio sarà
     * reso inutilizzabile.
     */
    genera_nuovo_pin : function () {

      // Creiamo un nuovo pin per l'utente eseguiamo la chiamata con POST
      // se il pin viene generato la chiamata torna con 204 No Content.
      this.overlay_text = "Generazione nuovo pin utente, attendere...";
      this.overlay_show = true;

      axios.post ( apiUrl.welfareapi.pin_identificativo )
      .then ( () => {

        this.overlay_show = false;

        // Se siamo qui il pin è stato generato, qunidi possiamo porre
        // il flag che indica l'esistenza del pin a true per aggiornare
        // l'interfaccia qualora sia la prima volta che lo generiamo.
        this.pin_exists = true;

        // Notifichiamo che è andato tutto bene.
        let message = "Il nuovo pin è stato generato con successo. Controlla la " +
                      "tua casella email. Il messaggio riportante il pin non sarà " +
                      "visibile nell'area notifiche."

        this.$bvModal.msgBoxOk( message, {
          title: 'Azione completa.',
          size: 'md',
          centered: true
        });

      })
      .catch ( ( error ) => {
        this.overlay_show = false;
        generalLib.backend_error_message_box( this, error.response.data );
      });

    }
  },
  created: function () {

    // Impostiamo il testo dell'overlay prima di visualizzarlo
    this.overlay_text = "Caricamento in corso, attendere...";
    this.overlay_show = true;

    // Verifichiamo se il pin utente esiste, usiamo la chiamata con GET
    axios.get( apiUrl.welfareapi.pin_identificativo )
    .then ( ( response ) => {
      this.overlay_show = false;
      // Settiamo il flag che ci dice se il pin esiste
      this.pin_exists = response.data.pin_exists;
    })
    .catch ( ( error ) => {
      this.overlay_show = false;
      let message = "Si è verificato un errore nel caricamento delle informazioni utente " +
                    "i dati mostrati in interfaccia potrebbero non essere corretti."
      generalLib.backend_error_message_box( this, message );
      console.error( error.response.data );
    });

  },
  components: {
    PageTagline,
    CustomOverlay
  }
}
</script>

<style scoped></style>